import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'react-bootstrap';
import { FormSelect } from '@components/Common/AwpFormInputs';
import AwpTreeSelect from '@components/Common/AwpTreeSelect';

import { propTypes } from 'react-bootstrap/esm/Image';

const HazardForecastPreferences = ({ programs, areas, rawAreas, getHazardAreas, formikProps, dto }) => {
  const [areaList, setAreaList] = useState(areas);

  useEffect(() => {
    if (dto?.program) {
      const areaList = filterObjectsByParentId(areas, dto.program.value);
      setAreaList(areaList);
    }
  }, [areas]);

  const filterObjectsByParentId = (data, programId) => {
    const filterRecursive = (item) => {
      const filteredItem = { ...item };

      if (filteredItem.treeLevel === 1 && filteredItem.parentId !== programId) {
        return null;
      }

      if (filteredItem.children && filteredItem.children.length > 0) {
        filteredItem.children = filteredItem.children?.map(filterRecursive).filter((child) => child !== null);
      }

      return filteredItem;
    };

    const filteredList = data?.map(filterRecursive).filter((item) => item !== null);

    return filteredList;
  };

  const programOnChange = (opt, setFieldValue) => {
    setFieldValue('hforecast.area', null, false);
    setAreaList(filterObjectsByParentId(rawAreas, opt.value));
  };

  const onHazardAreaChange = (currentNode, selectedNodes, setFieldValue) => {
    if (!selectedNodes || selectedNodes.length == 0) {
      setFieldValue('hforecast.area', null);
      return;
    }

    setFieldValue('hforecast.area', selectedNodes[0].value);
    const program = programs.find((x) => x.value === selectedNodes[0].programId);
    setFieldValue('hforecast.program', program);

    const areaList = getHazardAreas(rawAreas, selectedNodes[0].value);
    setAreaList(filterObjectsByParentId(areaList, selectedNodes[0].programId));
  };

  const handleReset = (formikProps) => {
    formikProps.setFieldValue('hforecast.program', { value: '' }, false);
    formikProps.setFieldValue('hforecast.area', { value: '' }, false);
    setAreaList(rawAreas);
  };

  return (
    <>
      <Card border="light" className="page-card">
        <Card.Header as="h3" style={{ backgroundColor: 'transparent' }}>
          HAZARD FORECAST
        </Card.Header>
        <Card.Body>
          <FormSelect
            className="avalanche-select"
            readOnly={false}
            name="hforecast.program"
            id="hforecast.program"
            label="Program"
            postChange={(e) => {
              programOnChange(e, formikProps.setFieldValue);
            }}
            options={programs}
            isMulti={false}
          />
          <AwpTreeSelect
            className="show-selected-item-yes awp-tree-select"
            name="hforecast.area.ddlb"
            id="hforecast.area.ddlb"
            label="Area"
            data={areaList}
            texts={{ placeholder: 'Select...' }}
            mode="radioSelect"
            onChange={(currentNode, selectedNodes) => {
              onHazardAreaChange(currentNode, selectedNodes, formikProps.setFieldValue);
            }}
          />
          <Button className="my-3" variant="outline-primary" onClick={() => handleReset(formikProps)}>
            Reset
          </Button>
        </Card.Body>
      </Card>
    </>
  );
};

HazardForecastPreferences.propTypes = {
  programs: PropTypes.arrayOf(PropTypes.object),
  areas: PropTypes.arrayOf(PropTypes.object),
  rawAreas: PropTypes.arrayOf(PropTypes.object),
  formikProps: PropTypes.object,
  dto: PropTypes.object,
};

export default HazardForecastPreferences;
